import React from "react";

import { PricingOptions } from "../../../../components";
import { GameInformationPricingAndAvailabilityDataType } from "../../../../models/forms";
import {
  LanguageItem,
  useLanguagesList,
} from "../../../GameInformationPage/PricingAndAvailabilitySubForm/languagesList";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyIdXboxAvailabilityPricingProps = {
  dataInForm: GameInformationPricingAndAvailabilityDataType;
};

const IdXboxAvailabilityPricingConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "supportedLanguages",
    {
      mapper: (
        data: GameInformationPricingAndAvailabilityDataType,
        _localizedStrings: Map<string, string>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        additionalData?: Map<string, any>
      ) => {
        if (!additionalData) {
          return null;
        }
        const languagesList = additionalData.get("languagesList") as LanguageItem[];
        return data.supportedLanguages.map(
          language => languagesList.find(item => item.value === language)?.label
        );
      },
    },
  ],
  ["otherLanguages", {}],
  [
    "monetizationStrategy",
    {
      title: "monetization",
      mapper: (
        data: GameInformationPricingAndAvailabilityDataType,
        localizedStrings: Map<string, string>
      ) =>
        localizedStrings.get(
          data.monetizationStrategy === PricingOptions.FreeToPlay ? "freeToPlay" : "premium"
        ),
    },
  ],
  [
    "howItWillGenerateMoney",
    {
      title: "indicateHowGameWillGenerateRevenue",
    },
  ],
  [
    "retentionMechanics",
    {
      title: "whatRetentionMechanicsAreInGame",
    },
  ],
  [
    "inGamePricePoints",
    {
      title: "describeYourInGamePricePoints",
    },
  ],
  [
    "whatPlayersCanSpendOn",
    {
      title: "describeWhatPlayersCanSpendOn",
    },
  ],
  [
    "timeUntilAPlayerIsPromptedToPay",
    {
      title: "howLongUntilANewPlayerWillPay",
    },
  ],
  [
    "howItemsCanBeGifted",
    {
      title: "describeHowItemsCanBeGifted",
    },
  ],
  [
    "subscriptionModel",
    {
      title: "describeYourSubscriptionModel",
    },
  ],
]);

export const ReadOnlyIdXboxAvailabilityPricing = ({
  dataInForm,
}: ReadOnlyIdXboxAvailabilityPricingProps) => {
  const extraStringsToLocalize = [
    "monetization",
    "suggestedRetailPrice",
    "indicateHowGameWillGenerateRevenue",
    "whatRetentionMechanicsAreInGame",
    "describeYourInGamePricePoints",
    "describeWhatPlayersCanSpendOn",
    "howLongUntilANewPlayerWillPay",
    "describeHowItemsCanBeGifted",
    "describeYourSubscriptionModel",
    "freeToPlay",
    "premium",
  ];

  const languagesList = useLanguagesList();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const additionalData = new Map<string, any>([["languagesList", languagesList]]);

  return (
    <ReadOnlyForm
      formConfig={IdXboxAvailabilityPricingConfig}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
      additionalData={additionalData}
    />
  );
};
